export default __webpack_public_path__ + "images/319ec0b3587e5bdcfeb8054d590bbb8d.svg";